import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "block bg-nucleus-white border-2 border-nucleus-primaryBlue p-1 text-nucleus-text text-center text-lg capitalize w-full rounded-full transition align-center flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, { to: _ctx.to }, {
    default: _withCtx(() => [
      _createElementVNode("button", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "icon-add text-3xl mr-4" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.name), 1)
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}